import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    console.log('CartDrawerComponent.open() called. Calling this.showDialog().'); // Added log
    this.showDialog(); // This should set the <dialog open> attribute
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  isDialogOpen() {
    if (this.dialog && typeof this.dialog.hasAttribute === 'function') {
      return this.dialog.hasAttribute('open');
    }
    if (typeof super.isOpen === 'function') return super.isOpen();
    if (typeof super.isOpen !== 'undefined') return super.isOpen;
    return false;
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

/**
 * ==================================================================================
 * START: JavaScript for Cart Recommendations Add to Cart
 * ==================================================================================
 */
document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('submit', function(event) {
    const recommendationForm = event.target.closest('.cart-recommendation-form');

    if (recommendationForm) {
      event.preventDefault();
      const formData = new FormData(recommendationForm);
      const submitButton = recommendationForm.querySelector('button[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      })
      .then(response => {
        if (!response.ok) return response.json().then(err => { throw new Error(err.description || err.message || 'Failed to add.'); });
        return response.json();
      })
      .then(responseData => {
        console.log('Recommended item added via AJAX:', responseData);
        return fetch('/cart.js').then(res => res.json());
      })
      .then(cartData => {
        console.log('Updated cart state from /cart.js:', cartData);

        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cartData }
        }));
        console.log('Dispatched cart:updated event.');

        console.log("Attempting to update cart by re-fetching section...");
        const parentSectionElement = recommendationForm.closest('[data-section-id]');
        let parentSectionId = 'header';
        if (parentSectionElement && parentSectionElement.dataset.sectionId) {
            parentSectionId = parentSectionElement.dataset.sectionId;
        } else {
            console.warn('Could not dynamically find parent section ID, using default:', parentSectionId);
        }
        console.log('Using parentSectionId:', parentSectionId);
        const cartDrawerContentSelector = '.cart-drawer__inner';

        fetch(`${window.Shopify.routes.root}?section_id=${parentSectionId}`)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const newDrawerContentSource = html.querySelector(cartDrawerContentSelector);
            const currentDrawerContentTarget = document.querySelector(cartDrawerContentSelector);

            if (newDrawerContentSource && currentDrawerContentTarget) {
              currentDrawerContentTarget.innerHTML = newDrawerContentSource.innerHTML;
              console.log('Cart drawer content updated by re-fetching section.');

              const cartDrawerElement = document.querySelector('cart-drawer-component');
              if (cartDrawerElement) {
                console.log('Found cart-drawer-component element after innerHTML update.');
                if (typeof cartDrawerElement.open === 'function') {
                  console.log('Attempting to call cartDrawerElement.open()');
                  cartDrawerElement.open(); // This calls showDialog() which should set <dialog open>

                  // For debugging, check the actual dialog attribute after a brief delay
                  // setTimeout(() => {
                  //   const dialogNode = cartDrawerElement.querySelector('dialog');
                  //   if (dialogNode) {
                  //     console.log('Dialog open attribute after .open() call (delayed check):', dialogNode.hasAttribute('open'));
                  //   }
                  // }, 100);

                } else {
                  console.warn('cartDrawerElement.open is not a function after innerHTML update.');
                }
              } else {
                console.warn('Could not find cart-drawer-component after innerHTML update.');
              }
            } else {
              console.warn('Could not find new or current cart drawer content for replacement using Method 2.');
              console.warn('New source selector used:', cartDrawerContentSelector, 'on fetched HTML from section_id:', parentSectionId);
              console.warn('Current target selector used:', cartDrawerContentSelector, 'on live DOM.');
              if (!newDrawerContentSource) console.warn('New content was NOT found in fetched HTML.');
              if (!currentDrawerContentTarget) console.warn('Current target was NOT found in live DOM.');
               window.location.href = window.Shopify.routes.cart_url;
            }
          })
          .catch(e => {
            console.error('Error re-fetching cart drawer section:', e);
             window.location.href = window.Shopify.routes.cart_url;
          });
      })
      .catch(error => {
        console.error('Error adding recommended item to cart (outer chain):', error.message);
        alert(`Error: ${error.message || 'Could not add item.'}`);
      })
      .finally(() => {
        if (submitButton) submitButton.disabled = false;
      });
    }
  });
});
/**
 * ==================================================================================
 * END: JavaScript for Cart Recommendations Add to Cart
 * ==================================================================================
 */